import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { DashboardHeader } from "@/components/dashboard/DashboardHeader";
import { SetupProgressCard } from "@/components/dashboard/SetupProgressCard";
import { AskCircleQuickCard } from "@/components/dashboard/AskCircleQuickCard";
import { ShortlistPanel } from "@/components/dashboard/ShortlistPanel";
import { InProgressPanel } from "@/components/dashboard/InProgressPanel";
import { RecommendationsPanel } from "@/components/dashboard/RecommendationsPanel";
import { QuickReviewPrompt } from "@/components/dashboard/QuickReviewPrompt";
import { WhatsHotSection } from "@/components/home/WhatsHotSection";
import { useDashboard } from "@/hooks/useDashboard";
import { Skeleton } from "@/components/ui/skeleton";

export default function Dashboard() {
  const { data, isLoading } = useDashboard();

  console.log('Dashboard data:', { 
    hasData: !!data, 
    hotProductsCount: data?.hotProducts?.length || 0,
    hotProducts: data?.hotProducts 
  });

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-1 container mx-auto px-4 py-8 space-y-8">
        {isLoading ? (
          <div className="space-y-8">
            <div className="flex flex-col lg:flex-row gap-6">
              <Skeleton className="h-32 flex-1" />
              <Skeleton className="h-32 lg:w-96" />
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <Skeleton className="h-96" />
              <Skeleton className="h-96" />
            </div>
            <Skeleton className="h-96" />
          </div>
        ) : (
          <>
            {/* Dashboard Header: Greeting + Stats */}
            <DashboardHeader data={data} />

            {/* Band 1: Setup Progress + AskCircle */}
            <section className="flex flex-col lg:flex-row lg:items-start gap-6">
              <SetupProgressCard />
              <AskCircleQuickCard />
            </section>

            {/* Band 2: Your World */}
            <section className="grid grid-cols-1 lg:grid-cols-2 gap-6">
              <div className="space-y-6">
                <ShortlistPanel favorites={data?.favorites} />
                <QuickReviewPrompt />
              </div>
              <InProgressPanel 
                recentlyViewed={data?.recentlyViewed}
                conversations={data?.recentConversations}
              />
            </section>

            {/* Band 3: Recommendations */}
            <section>
          <RecommendationsPanel 
            products={data?.recommendedProducts}
            agentProfile={data?.agentProfile}
          />
            </section>

            {/* Band 4: What's Hot */}
            {data?.hotProducts && data.hotProducts.length > 0 && (
              <section>
                <WhatsHotSection hotProducts={data.hotProducts} />
              </section>
            )}
          </>
        )}
      </main>
      
      <Footer />
    </div>
  );
}
